import { render, staticRenderFns } from "./TxRendererStatus.vue?vue&type=template&id=ae6d35e2&"
import script from "./TxRendererStatus.vue?vue&type=script&lang=js&"
export * from "./TxRendererStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports